"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles(theme) {
  return {
    current: {
      color: _colors["default"].purple
    },
    back: {
      color: _colors["default"].mediumGray
    },
    crumb: {
      display: 'flex',
      fontSize: 14,
      fontWeight: 600,
      fontFamily: 'proxima-soft, sans-serif'
    },
    icon: {
      marginRight: 8,
      width: 20,
      height: 20
    }
  };
};

exports.styles = styles;